import React, { useEffect } from 'react';
import { login, logout } from '../Utils/Cookies.js';
import api from "../tbrosApi.js"
import butterflyApi from '../ButterflyApi.js';
import {
  buildAndroidAppHandoffUrl,
  consumeSocialLoginFlow,
  isAndroidAppLoginSource,
  resolveTrustedWebUrl,
} from './SocialLoginUtils.js';

const NaverLoginCallback = () => {

  const queryParams = new URLSearchParams(window.location.search)
  const redirectUri = encodeURIComponent(window.location.origin + `/auth/callback/naver`)
  const code = queryParams.get("code")
  const state = queryParams.get("state")
  const socialLoginFlow = consumeSocialLoginFlow(state)
  const successCallback = (socialLoginFlow && socialLoginFlow.successCallback) || queryParams.get("successCallback")
  const failCallback = (socialLoginFlow && socialLoginFlow.failCallback) || queryParams.get("failCallback")
  const isAndroidAppFlow = isAndroidAppLoginSource(socialLoginFlow && socialLoginFlow.source)

  const getValidCallback = (callback) => {
    if (!callback || callback === "null" || callback.trim() === "") {
      return null
    }
    return callback
  }

  const validSuccessCallback = getValidCallback(successCallback)
  const validFailCallback = getValidCallback(failCallback)
  const failUrl = resolveTrustedWebUrl(validFailCallback, "/")

  const getTargetWebUrl = async () => {
    const heroesResponse = await butterflyApi.getHeroes()
    if (heroesResponse && heroesResponse.items.length > 0) {
      const heroes = heroesResponse.items
      localStorage.setItem("heroes", JSON.stringify(heroes))
      const heroNo = localStorage.getItem("heroNo")
      if (heroes.filter(_hero => String(_hero.heroNo) === String(heroNo)).length === 0) {
        localStorage.setItem("heroNo", heroes[0].heroNo)
      }

      return resolveTrustedWebUrl(validSuccessCallback, "/")
    }

    return resolveTrustedWebUrl(validSuccessCallback, "/heroes")
  }

  const getAccessToken = async () => {
    if (!code || !state) {
      alert("Invalid login request.")
      window.location = failUrl
      return
    }

    const response = await api.get(`/login/naver?code=${code}&state=${state}&redirectUrl=${redirectUri}`)
    if (response && response.data && response.data.accessToken) {
      const accessToken = response.data.accessToken
      await login(accessToken)
      const targetWebUrl = await getTargetWebUrl()

      if (isAndroidAppFlow) {
        const handoffUrl = buildAndroidAppHandoffUrl({
          accessToken,
          targetWebUrl,
          fallbackUrl: targetWebUrl,
        })

        if (handoffUrl) {
          window.location.replace(handoffUrl)
          return
        }
      }

      window.location = targetWebUrl
    } else {
      alert("로그인에 실패하였습니다.")
      logout()
      window.location = failUrl
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getAccessToken()
  }, []);

  return (
    <></>
  )
}

export default NaverLoginCallback
